import axios from "axios";
import home from "../../home/home";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  logOut,
} from "../../../common/utils";
import jwt_decode from "jwt-decode";
export default class DashboardRecuperoCrediti {
  getDataChart(onSuccess) {
    var dataChart = [
      {
        name: "13/12/21",
        uv: 150,
      },
      {
        name: "14/12/21",
        uv: 110,
      },
      {
        name: "15/12/21",
        uv: 170,
      },
      {
        name: "16/12/21",
        uv: 180,
      },
      {
        name: "17/12/21",
        uv: 90,
      },
      {
        name: "18/12/21",
        uv: 0,
      },
      {
        name: "19/12/21",
        uv: 0,
      },
    ];
    onSuccess(dataChart);
  }

  getDataTableSanzioni(dataInizio, dataFine, onSuccess) {
    var headerDataTableSanzione = [
      { label: "Num. Ricupero Crediti", field: "numRecuperoCredito", width: 270 },
      { label: "Num. Ingiunzione", field: "numInginzione", width: 270 },
      {
        label: "Num. Sanzione",
        field: "numSanzione",
        width: 100,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
        },
      },
      { label: "Importo", field: "importo", width: 270 },
      { label: "Data Recupero Crediti", field: "dataCreazione", width: 270 },
      
    ];
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };

    const dataOreInizio = new Date().setDate(new Date().getDate() - 30);
    const dataOraCorrettaInizio = new Date(dataOreInizio).setHours(0, 0, 0);

    dataInizio === ""
      ? (dataInizio = dataOraCorrettaInizio)
      : (dataInizio = +new Date(dataInizio).setHours(0, 0, 0));
    dataFine === ""
      ? (dataFine = +new Date().setHours(23, 59, 59))
      : (dataFine = +new Date(dataFine).setHours(23, 59, 59));

    axios
      .get(host + "/api/v1/recuperocredito/listaRecuperocredito/"+ dataInizio + "/" + dataFine,  configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(headerDataTableSanzione, result.data);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore ricerca composizione " + error);
          onSuccess(headerDataTableSanzione, []);
        }
      );
  }


  getExportCSV(stato, dataInizio, dataFine, onSuccess) {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    let host = process.env.REACT_APP_API_URL;
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };

    // console.log(JSON.stringify(jsonSanzione));
    const dataOreInizio =  new Date().setDate(new Date().getDate() - 30);
    const dataOraCorrettaInizio  = new Date(dataOreInizio).setHours(0, 0, 0);

    dataInizio === ""
      ? (dataInizio = dataOraCorrettaInizio)
      : (dataInizio = +new Date(dataInizio).setHours(0, 0, 0));
    dataFine === ""
      ? (dataFine = +new Date().setHours(23,59, 59))
      : (dataFine = +new Date(dataFine).setHours(23,59, 59));
    axios
      .get(host + "/api/v1/ingiunzioni/esportaIngiunzioni/" + stato + "/" + dataInizio + "/" + dataFine, configHeaders)
      .then(
        function (result) {
          // console.log(result.status);
          // onSuccess(result.data);
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("Errore di  " + error);
          onSuccess("");
        }
      );
  }
}
